import VueRouter from 'vue-router';
import core from '@/core';


const router = new VueRouter({
  routes: [],
});

router.beforeEach((to, from, next) => {
  const meta = to?.meta || {
    title: 'Mini MAG',
    isAuthentication: false,
  };
  core.promise.finally(() => {
    core.title.set(meta.title || 'Mini MAG');
    if (meta.isAuthentication && !core.isAuthentication) {
      next('/authentication');
      return;
    }
    next();
  });
});

export default router;

export const RouterVue = {
  install(Vue) {
    Vue.use(VueRouter);
  },
  router,
};
